<template>
  <DrawerPage defaultIsOpen drawerName="creationCommande">
    <template #content><CreationCommandeForm /></template>
    <template #drawer><BrouillonList /></template>
  </DrawerPage>
</template>

<script setup>

import {UtilisateurStores} from "@/stores/UtilisateurStores";
import {router} from "@/routeur";
import {NotificationStores} from "@/stores/NotificationStores";
import {t} from "@/utils/Traduction";
import CreationCommandeForm from "@/components/organismes/CreationCommandeForm.vue";
import BrouillonList from "@/components/organismes/BrouillonList.vue";
import DrawerPage from "@/components/organismes/DrawerPage.vue";

const utilisateurStore = UtilisateurStores();
  const notificationStore = NotificationStores();

  if(!utilisateurStore.isConnected) {
    notificationStore.addNotification(t("youNeedToBeConnectedToAccessThisPage"), 'error');
  router.push({ path: "/"});
}

utilisateurStore.loadClients();

</script>

<style scoped>

</style>